module.exports = __webpack_public_path__ + "static/allForMe-a842bc507a81d44d79bca8eafdcbcb46.png";